import React from 'react';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import ScenarioSelectionAssumptionsMetaOverride from './ScenarioSelectionAssumptionsMetaOverride';
import ScenarioSelectionAssumptionsLayout from './ScenarioSelectionAssumptionsLayout';

const ScenarioSelectionAssumptions = ({ relationship }) => {
  const { collection, loading, loadingError } = useLink(relationship.link('related'));

  return (
    <DataContainer
      component={MetaCollectionRenderer}
      componentProps={{
        collection,
        layout: ScenarioSelectionAssumptionsLayout,
        metaOverrideSet: ScenarioSelectionAssumptionsMetaOverride,
      }}
      loading={loading}
      loadingError={loadingError}
    />
  );
};

ScenarioSelectionAssumptions.propTypes = {
  relationship: PropTypes.object.isRequired,
};
ScenarioSelectionAssumptions.defaultProps = {};

export default ScenarioSelectionAssumptions;
